import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';

interface SiteConfigValue {
  categories: string[];
  installationProducts: { product_id: string; title: string }[];
  loading: boolean;
}

const SiteConfigContext = createContext<SiteConfigValue>({
  categories: [],
  installationProducts: [],
  loading: true,
});

export function SiteConfigProvider({ children }: { children: ReactNode }) {
  const [categories, setCategories] = useState<string[]>([]);
  const [installationProducts, setInstallationProducts] = useState<{ product_id: string; title: string }[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetch('/.netlify/functions/public-api?endpoint=site-config')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch site config');
        return res.json();
      })
      .then(({ categories, installationProducts }) => {
        if (cancelled) return;
        setCategories(categories);
        setInstallationProducts(installationProducts);
        setLoading(false);
      })
      .catch(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return (
    <SiteConfigContext.Provider value={{ categories, installationProducts, loading }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig(): SiteConfigValue {
  return useContext(SiteConfigContext);
}
